// @ts-nocheck
/**
 * Benefits Icons Auto-Scroll Controller (Mobile)
 */
function initBenefitsSection(listElement) {
  const list = /** @type {HTMLElement} */ (listElement);
  /** @type {NodeListOf<HTMLElement>} */
  const items = list.querySelectorAll('.benefit-item');
  if (items.length <= 1) return;

  const interval = parseInt(list.dataset.interval || '4000', 10) || 4000;
  let currentIndex = 0;
  /** @type {ReturnType<typeof setInterval> | null} */
  let timer = null;

  function moveToNextBenefit() {
    if (window.innerWidth >= 750) return;
    currentIndex++;
    if (currentIndex >= items.length) currentIndex = 0;
    const item = items[currentIndex];
    if (!item) return;

    list.scrollTo({
      left: item.offsetLeft - list.offsetLeft - 18,
      behavior: 'smooth'
    });
  }

  function startAutoChange() {
    stopAutoChange();
    timer = setInterval(moveToNextBenefit, interval);
  }

  function stopAutoChange() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  startAutoChange();
  list.addEventListener('mouseenter', stopAutoChange);
  list.addEventListener('mouseleave', startAutoChange);
  list.addEventListener('touchstart', stopAutoChange, { passive: true });
  list.addEventListener('touchend', () => setTimeout(startAutoChange, 2500), { passive: true });
}

function initAllBenefits() {
  document.querySelectorAll('.benefits-list[data-auto-change="true"]').forEach(initBenefitsSection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllBenefits);
} else {
  initAllBenefits();
}
